/*
 * @Author: bbqin
 * @Date: 2023-03-14 15:34:54
 * @LastEditTime: 2023-04-11 20:32:08
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\useAffix\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Closest, isFunction } from '../../libs/utils';
require('./index.less');

// const h1Elem = document.querySelector('h1');
// const pElem = document.querySelector('p');
// const divElem = document.querySelector('body > div');
// const slider = document.querySelector('input[type="range"]');
// const checkbox = document.querySelector('input[type="checkbox"]');

// divElem.style.width = '600px';

// slider.addEventListener('input', () => {
//   divElem.style.width = `${slider.value}px`;
// })

// const resizeObserver = new ResizeObserver((entries) => {
//   for (const entry of entries) {
//     if (entry.contentBoxSize) {
//       // Firefox implements `contentBoxSize` as a single content rect, rather than an array
//       const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;

//       h1Elem.style.fontSize = `${Math.max(1.5, contentBoxSize.inlineSize / 200)}rem`;
//       pElem.style.fontSize = `${Math.max(1, contentBoxSize.inlineSize / 600)}rem`;
//     } else {
//       h1Elem.style.fontSize = `${Math.max(1.5, entry.contentRect.width / 200)}rem`;
//       pElem.style.fontSize = `${Math.max(1, entry.contentRect.width / 600)}rem`;
//     }
//   }

//   console.log('Size changed');
// });

// resizeObserver.observe(divElem);

// checkbox.addEventListener('change', () => {
//   if (checkbox.checked) {
//     resizeObserver.observe(divElem);
//   } else {
//     resizeObserver.unobserve(divElem);
//   }
// });

function useAffix(Wallet) {
    class Affix extends Component {
        constructor(props) {
            super(props);
        }

        componentDidMount() {
            const { headerAffix } = this.props;
            if (headerAffix) {
                const $wallet = ReactDOM.findDOMNode(this);
                const $scroll = $wallet && Closest($wallet, '.card-list-wrapper');
                $scroll && $scroll.addEventListener('scroll', this.onScroll);
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {

        }

        componentWillUnmount() {
            const { headerAffix } = this.props;
            if (headerAffix) {
                const $wallet = ReactDOM.findDOMNode(this);
                const $scroll = $wallet && Closest($wallet, '.card-list-wrapper');
                $scroll && $scroll.removeEventListener('scroll', this.onScroll);
            }
        }

        componentDidUpdate() {
            const $wallet = ReactDOM.findDOMNode(this);
            const $scroll = $wallet && Closest($wallet, '.card-list-wrapper');
            const hasSCroll = this.hasScrolled($scroll, 'vertical');
            // 显示
            if (!hasSCroll) {
                const $walletHeader = $wallet.querySelector('.card-wallet-header');
                $walletHeader.style.opacity = '1';
            }
        }

        // 是否有滚动条
        hasScrolled(el, direction = "horizontal") {
            if (!el) {
                return false;
            }
            // 判断一下overflow = hidden 情况
            let overflow =
                (el.currentStyle && el.currentStyle.overflow) ||
                window.getComputedStyle(el).getPropertyValue("overflow");
            if (overflow === "hidden") {return false;}
            if (direction === "vertical") {
                return el.scrollHeight > el.clientHeight;
            } else if (direction === "horizontal") {
                return el.scrollWidth > el.clientWidth;
            }
        }

        onScroll = e => {
            const $wallet = ReactDOM.findDOMNode(this);
            const $scroll = $wallet && Closest($wallet, '.card-list-wrapper');
            const hasSCroll = this.hasScrolled($scroll, 'vertical');
            if ($scroll && hasSCroll) {
                const $walletHeader = $wallet.querySelector('.card-wallet-header');
                const headerHeight = $walletHeader?.offsetHeight;
                const walletHeight = $wallet?.offsetHeight;
                const scrollPosition = $scroll.getBoundingClientRect()?.top;
                const walletPosition = $wallet.getBoundingClientRect()?.top;
                const position = walletPosition - scrollPosition;
                const extraHeight = position + walletHeight;
                // 隐藏固定元素
                if (extraHeight < 0) {
                    $walletHeader.style.opacity = '1';
                } else if (extraHeight < headerHeight + 2) {
                    // $walletHeader.style.animation = 'walletHeaderFadeOut 0.3s';
                    $walletHeader.style.opacity = '0';
                    $walletHeader.style.display = 'flex';
                    $walletHeader.style.position = 'relative';
                    $walletHeader.style.top = 'auto';
                } else if (position < 0) {
                    $walletHeader.style.display = 'flex';
                    $walletHeader.style.position = 'sticky';
                    $walletHeader.style.top = '0';
                    // 开始固定
                    $walletHeader.style.left = '0';
                    if (extraHeight < headerHeight * 2) {
                        $walletHeader.style.opacity = (extraHeight - headerHeight) / headerHeight;
                    } else {
                        $walletHeader.style.opacity = '1';
                    }
                } else {
                    // 还原固定
                    $walletHeader.style.display = 'flex';
                    $walletHeader.style.position = 'relative';
                    $walletHeader.style.left = 'auto';
                    $walletHeader.style.top = 'auto';
                    $walletHeader.style.opacity = '1';
                }
            }
        }

        render() {

            const { onExpand } = this.props;

            return <Wallet {...this.props} onExpand={(...params) => {
                const $wallet = ReactDOM.findDOMNode(this);
                const $scroll = $wallet && Closest($wallet, '.card-list-wrapper');
                const hasSCroll = this.hasScrolled($scroll, 'vertical');
                // 显示
                if (!hasSCroll && $scroll) {
                    const $walletHeaders = $scroll.querySelectorAll('.card-wallet-header');
                    Array.from($walletHeaders).forEach(element => {
                        element.style.opacity = '1';
                    });
                }

                isFunction(onExpand) && onExpand(...params);
            }} />;
        }
    }

    return Affix;
}

export default useAffix;